// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file application-metadata-message.proto (syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file application-metadata-message.proto.
 */
export const file_application_metadata_message: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
  )

/**
 * @generated from message ApplicationMetadataMessage
 */
export type ApplicationMetadataMessage =
  Message<'ApplicationMetadataMessage'> & {
    /**
     * Signature of the payload field
     *
     * @generated from field: bytes signature = 1;
     */
    signature: Uint8Array

    /**
     * This is the encoded protobuf of the application level message, i.e ChatMessage
     *
     * @generated from field: bytes payload = 2;
     */
    payload: Uint8Array

    /**
     * The type of protobuf message sent
     *
     * @generated from field: ApplicationMetadataMessage.Type type = 3;
     */
    type: ApplicationMetadataMessage_Type
  }

/**
 * Describes the message ApplicationMetadataMessage.
 * Use `create(ApplicationMetadataMessageSchema)` to create a new message.
 */
export const ApplicationMetadataMessageSchema: GenMessage<ApplicationMetadataMessage> =
  /*@__PURE__*/
  messageDesc(file_application_metadata_message, 0)

/**
 * @generated from enum ApplicationMetadataMessage.Type
 */
export enum ApplicationMetadataMessage_Type {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CHAT_MESSAGE = 1;
   */
  CHAT_MESSAGE = 1,

  /**
   * @generated from enum value: CONTACT_UPDATE = 2;
   */
  CONTACT_UPDATE = 2,

  /**
   * @generated from enum value: MEMBERSHIP_UPDATE_MESSAGE = 3;
   */
  MEMBERSHIP_UPDATE_MESSAGE = 3,

  /**
   * @generated from enum value: SYNC_PAIR_INSTALLATION = 4;
   */
  SYNC_PAIR_INSTALLATION = 4,

  /**
   * @generated from enum value: DEPRECATED_SYNC_INSTALLATION = 5 [deprecated = true];
   * @deprecated
   */
  DEPRECATED_SYNC_INSTALLATION = 5,

  /**
   * @generated from enum value: REQUEST_ADDRESS_FOR_TRANSACTION = 6;
   */
  REQUEST_ADDRESS_FOR_TRANSACTION = 6,

  /**
   * @generated from enum value: ACCEPT_REQUEST_ADDRESS_FOR_TRANSACTION = 7;
   */
  ACCEPT_REQUEST_ADDRESS_FOR_TRANSACTION = 7,

  /**
   * @generated from enum value: DECLINE_REQUEST_ADDRESS_FOR_TRANSACTION = 8;
   */
  DECLINE_REQUEST_ADDRESS_FOR_TRANSACTION = 8,

  /**
   * @generated from enum value: REQUEST_TRANSACTION = 9;
   */
  REQUEST_TRANSACTION = 9,

  /**
   * @generated from enum value: SEND_TRANSACTION = 10;
   */
  SEND_TRANSACTION = 10,

  /**
   * @generated from enum value: DECLINE_REQUEST_TRANSACTION = 11;
   */
  DECLINE_REQUEST_TRANSACTION = 11,

  /**
   * @generated from enum value: SYNC_INSTALLATION_CONTACT_V2 = 12;
   */
  SYNC_INSTALLATION_CONTACT_V2 = 12,

  /**
   * @generated from enum value: SYNC_INSTALLATION_ACCOUNT = 13;
   */
  SYNC_INSTALLATION_ACCOUNT = 13,

  /**
   * @generated from enum value: CONTACT_CODE_ADVERTISEMENT = 15;
   */
  CONTACT_CODE_ADVERTISEMENT = 15,

  /**
   * @generated from enum value: PUSH_NOTIFICATION_REGISTRATION = 16;
   */
  PUSH_NOTIFICATION_REGISTRATION = 16,

  /**
   * @generated from enum value: PUSH_NOTIFICATION_REGISTRATION_RESPONSE = 17;
   */
  PUSH_NOTIFICATION_REGISTRATION_RESPONSE = 17,

  /**
   * @generated from enum value: PUSH_NOTIFICATION_QUERY = 18;
   */
  PUSH_NOTIFICATION_QUERY = 18,

  /**
   * @generated from enum value: PUSH_NOTIFICATION_QUERY_RESPONSE = 19;
   */
  PUSH_NOTIFICATION_QUERY_RESPONSE = 19,

  /**
   * @generated from enum value: PUSH_NOTIFICATION_REQUEST = 20;
   */
  PUSH_NOTIFICATION_REQUEST = 20,

  /**
   * @generated from enum value: PUSH_NOTIFICATION_RESPONSE = 21;
   */
  PUSH_NOTIFICATION_RESPONSE = 21,

  /**
   * @generated from enum value: EMOJI_REACTION = 22;
   */
  EMOJI_REACTION = 22,

  /**
   * @generated from enum value: GROUP_CHAT_INVITATION = 23;
   */
  GROUP_CHAT_INVITATION = 23,

  /**
   * @generated from enum value: CHAT_IDENTITY = 24;
   */
  CHAT_IDENTITY = 24,

  /**
   * @generated from enum value: COMMUNITY_DESCRIPTION = 25;
   */
  COMMUNITY_DESCRIPTION = 25,

  /**
   * @generated from enum value: COMMUNITY_INVITATION = 26 [deprecated = true];
   * @deprecated
   */
  COMMUNITY_INVITATION = 26,

  /**
   * @generated from enum value: COMMUNITY_REQUEST_TO_JOIN = 27;
   */
  COMMUNITY_REQUEST_TO_JOIN = 27,

  /**
   * @generated from enum value: PIN_MESSAGE = 28;
   */
  PIN_MESSAGE = 28,

  /**
   * @generated from enum value: EDIT_MESSAGE = 29;
   */
  EDIT_MESSAGE = 29,

  /**
   * @generated from enum value: STATUS_UPDATE = 30;
   */
  STATUS_UPDATE = 30,

  /**
   * @generated from enum value: DELETE_MESSAGE = 31;
   */
  DELETE_MESSAGE = 31,

  /**
   * @generated from enum value: SYNC_INSTALLATION_COMMUNITY = 32;
   */
  SYNC_INSTALLATION_COMMUNITY = 32,

  /**
   * @generated from enum value: ANONYMOUS_METRIC_BATCH = 33;
   */
  ANONYMOUS_METRIC_BATCH = 33,

  /**
   * @generated from enum value: SYNC_CHAT_REMOVED = 34;
   */
  SYNC_CHAT_REMOVED = 34,

  /**
   * @generated from enum value: SYNC_CHAT_MESSAGES_READ = 35;
   */
  SYNC_CHAT_MESSAGES_READ = 35,

  /**
   * @generated from enum value: BACKUP = 36;
   */
  BACKUP = 36,

  /**
   * @generated from enum value: SYNC_ACTIVITY_CENTER_READ = 37;
   */
  SYNC_ACTIVITY_CENTER_READ = 37,

  /**
   * @generated from enum value: SYNC_ACTIVITY_CENTER_ACCEPTED = 38;
   */
  SYNC_ACTIVITY_CENTER_ACCEPTED = 38,

  /**
   * @generated from enum value: SYNC_ACTIVITY_CENTER_DISMISSED = 39;
   */
  SYNC_ACTIVITY_CENTER_DISMISSED = 39,

  /**
   * @generated from enum value: SYNC_BOOKMARK = 40;
   */
  SYNC_BOOKMARK = 40,

  /**
   * @generated from enum value: SYNC_CLEAR_HISTORY = 41;
   */
  SYNC_CLEAR_HISTORY = 41,

  /**
   * @generated from enum value: SYNC_SETTING = 42;
   */
  SYNC_SETTING = 42,

  /**
   * @generated from enum value: COMMUNITY_MESSAGE_ARCHIVE_MAGNETLINK = 43;
   */
  COMMUNITY_MESSAGE_ARCHIVE_MAGNETLINK = 43,

  /**
   * @generated from enum value: SYNC_PROFILE_PICTURES = 44;
   */
  SYNC_PROFILE_PICTURES = 44,

  /**
   * @generated from enum value: SYNC_ACCOUNT = 45;
   */
  SYNC_ACCOUNT = 45,

  /**
   * @generated from enum value: ACCEPT_CONTACT_REQUEST = 46;
   */
  ACCEPT_CONTACT_REQUEST = 46,

  /**
   * @generated from enum value: RETRACT_CONTACT_REQUEST = 47;
   */
  RETRACT_CONTACT_REQUEST = 47,

  /**
   * @generated from enum value: COMMUNITY_REQUEST_TO_JOIN_RESPONSE = 48;
   */
  COMMUNITY_REQUEST_TO_JOIN_RESPONSE = 48,

  /**
   * @generated from enum value: SYNC_COMMUNITY_SETTINGS = 49;
   */
  SYNC_COMMUNITY_SETTINGS = 49,

  /**
   * @generated from enum value: REQUEST_CONTACT_VERIFICATION = 50;
   */
  REQUEST_CONTACT_VERIFICATION = 50,

  /**
   * @generated from enum value: ACCEPT_CONTACT_VERIFICATION = 51;
   */
  ACCEPT_CONTACT_VERIFICATION = 51,

  /**
   * @generated from enum value: DECLINE_CONTACT_VERIFICATION = 52;
   */
  DECLINE_CONTACT_VERIFICATION = 52,

  /**
   * @generated from enum value: SYNC_TRUSTED_USER = 53;
   */
  SYNC_TRUSTED_USER = 53,

  /**
   * @generated from enum value: SYNC_VERIFICATION_REQUEST = 54;
   */
  SYNC_VERIFICATION_REQUEST = 54,

  /**
   * @generated from enum value: SYNC_CONTACT_REQUEST_DECISION = 56;
   */
  SYNC_CONTACT_REQUEST_DECISION = 56,

  /**
   * @generated from enum value: COMMUNITY_REQUEST_TO_LEAVE = 57;
   */
  COMMUNITY_REQUEST_TO_LEAVE = 57,

  /**
   * @generated from enum value: SYNC_DELETE_FOR_ME_MESSAGE = 58;
   */
  SYNC_DELETE_FOR_ME_MESSAGE = 58,

  /**
   * @generated from enum value: SYNC_SAVED_ADDRESS = 59;
   */
  SYNC_SAVED_ADDRESS = 59,

  /**
   * @generated from enum value: COMMUNITY_CANCEL_REQUEST_TO_JOIN = 60;
   */
  COMMUNITY_CANCEL_REQUEST_TO_JOIN = 60,

  /**
   * @generated from enum value: CANCEL_CONTACT_VERIFICATION = 61;
   */
  CANCEL_CONTACT_VERIFICATION = 61,

  /**
   * @generated from enum value: SYNC_KEYPAIR = 62;
   */
  SYNC_KEYPAIR = 62,

  /**
   * @generated from enum value: SYNC_SOCIAL_LINKS = 63;
   */
  SYNC_SOCIAL_LINKS = 63,

  /**
   * @generated from enum value: SYNC_ENS_USERNAME_DETAIL = 64;
   */
  SYNC_ENS_USERNAME_DETAIL = 64,

  /**
   * @generated from enum value: COMMUNITY_EVENTS_MESSAGE = 67;
   */
  COMMUNITY_EVENTS_MESSAGE = 67,

  /**
   * @generated from enum value: COMMUNITY_EDIT_SHARED_ADDRESSES = 68;
   */
  COMMUNITY_EDIT_SHARED_ADDRESSES = 68,

  /**
   * @generated from enum value: SYNC_ACCOUNT_CUSTOMIZATION_COLOR = 69;
   */
  SYNC_ACCOUNT_CUSTOMIZATION_COLOR = 69,

  /**
   * @generated from enum value: SYNC_ACCOUNTS_POSITIONS = 70;
   */
  SYNC_ACCOUNTS_POSITIONS = 70,

  /**
   * @generated from enum value: COMMUNITY_EVENTS_MESSAGE_REJECTED = 71;
   */
  COMMUNITY_EVENTS_MESSAGE_REJECTED = 71,

  /**
   * @generated from enum value: COMMUNITY_PRIVILEGED_USER_SYNC_MESSAGE = 72;
   */
  COMMUNITY_PRIVILEGED_USER_SYNC_MESSAGE = 72,

  /**
   * @generated from enum value: COMMUNITY_SHARD_KEY = 73;
   */
  COMMUNITY_SHARD_KEY = 73,

  /**
   * @generated from enum value: SYNC_CHAT = 74;
   */
  SYNC_CHAT = 74,

  /**
   * @generated from enum value: SYNC_ACTIVITY_CENTER_DELETED = 75;
   */
  SYNC_ACTIVITY_CENTER_DELETED = 75,

  /**
   * @generated from enum value: SYNC_ACTIVITY_CENTER_UNREAD = 76;
   */
  SYNC_ACTIVITY_CENTER_UNREAD = 76,

  /**
   * @generated from enum value: SYNC_ACTIVITY_CENTER_COMMUNITY_REQUEST_DECISION = 77;
   */
  SYNC_ACTIVITY_CENTER_COMMUNITY_REQUEST_DECISION = 77,

  /**
   * @generated from enum value: SYNC_TOKEN_PREFERENCES = 78;
   */
  SYNC_TOKEN_PREFERENCES = 78,

  /**
   * @generated from enum value: COMMUNITY_PUBLIC_SHARD_INFO = 79;
   */
  COMMUNITY_PUBLIC_SHARD_INFO = 79,

  /**
   * @generated from enum value: SYNC_COLLECTIBLE_PREFERENCES = 80;
   */
  SYNC_COLLECTIBLE_PREFERENCES = 80,

  /**
   * @generated from enum value: COMMUNITY_USER_KICKED = 81;
   */
  COMMUNITY_USER_KICKED = 81,

  /**
   * @generated from enum value: SYNC_PROFILE_SHOWCASE_PREFERENCES = 82;
   */
  SYNC_PROFILE_SHOWCASE_PREFERENCES = 82,

  /**
   * @generated from enum value: COMMUNITY_PUBLIC_STORENODES_INFO = 83;
   */
  COMMUNITY_PUBLIC_STORENODES_INFO = 83,

  /**
   * @generated from enum value: COMMUNITY_REEVALUATE_PERMISSIONS_REQUEST = 84;
   */
  COMMUNITY_REEVALUATE_PERMISSIONS_REQUEST = 84,
}

/**
 * Describes the enum ApplicationMetadataMessage.Type.
 */
export const ApplicationMetadataMessage_TypeSchema: GenEnum<ApplicationMetadataMessage_Type> =
  /*@__PURE__*/
  enumDesc(file_application_metadata_message, 0, 0)
